/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts';

import type { EulerBeatsV2 } from '../EulerBeatsV2';

export class EulerBeatsV2__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _name: string,
    _symbol: string,
    _uri: string,
    overrides?: Overrides
  ): Promise<EulerBeatsV2> {
    return super.deploy(_name, _symbol, _uri, overrides || {}) as Promise<EulerBeatsV2>;
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    _uri: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_name, _symbol, _uri, overrides || {});
  }
  attach(address: string): EulerBeatsV2 {
    return super.attach(address) as EulerBeatsV2;
  }
  connect(signer: Signer): EulerBeatsV2__factory {
    return super.connect(signer) as EulerBeatsV2__factory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): EulerBeatsV2 {
    return new Contract(address, _abi, signerOrProvider) as EulerBeatsV2;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: '_name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string',
      },
      {
        internalType: 'string',
        name: '_uri',
        type: 'string',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'originalsMinted',
        type: 'uint256',
      },
    ],
    name: 'MintOriginal',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'priceReceived',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'nextPrintPrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'nextBurnPrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'printsSupply',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reserve',
        type: 'uint256',
      },
    ],
    name: 'PrintBurned',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'pricePaid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'nextPrintPrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'nextBurnPrice',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'printsSupply',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'royaltyPaid',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'reserve',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'royaltyRecipient',
        type: 'address',
      },
    ],
    name: 'PrintMinted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]',
      },
    ],
    name: 'TransferBatch',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'TransferSingle',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'URI',
    type: 'event',
  },
  {
    inputs: [],
    name: 'A',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'B',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'C',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_PRINT_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_SEEDS_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'PRINTS_FLAG_BIT',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SIG_DIGITS',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_script',
        type: 'string',
      },
    ],
    name: 'addScript',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minimumSupply',
        type: 'uint256',
      },
    ],
    name: 'burnPrint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'burnPrintEnabled',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'supply',
        type: 'uint256',
      },
    ],
    name: 'getBurnPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
    ],
    name: 'getPricesBySeed',
    outputs: [
      {
        internalType: 'uint256',
        name: 'printPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'nextPrintPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'burnPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'nextBurnPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'supply',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'supply',
        type: 'uint256',
      },
    ],
    name: 'getPricesBySupply',
    outputs: [
      {
        internalType: 'uint256',
        name: 'printPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'nextPrintPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'burnPrice',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'nextBurnPrice',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'printNumber',
        type: 'uint256',
      },
    ],
    name: 'getPrintPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
    ],
    name: 'getPrintTokenIdFromSeed',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'getScriptAtIndex',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'isSeedId',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'mint',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'mintEnabled',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
      {
        internalType: 'address payable',
        name: '_owner',
        type: 'address',
      },
    ],
    name: 'mintPrint',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'mintPrintEnabled',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'originalsMinted',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'reserve',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'resetScriptCount',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'scriptCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'scripts',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'seed',
        type: 'uint256',
      },
    ],
    name: 'seedToPrintsSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'enabled',
        type: 'bool',
      },
    ],
    name: 'setBurnPrintEnabled',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'enabled',
        type: 'bool',
      },
    ],
    name: 'setContractMintPrintEnabled',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'locked',
        type: 'bool',
      },
    ],
    name: 'setLocked',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'enabled',
        type: 'bool',
      },
    ],
    name: 'setMintEnabled',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'enabled',
        type: 'bool',
      },
    ],
    name: 'setMintPrintEnabled',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: 'newuri',
        type: 'string',
      },
    ],
    name: 'setURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'string',
        name: '_script',
        type: 'string',
      },
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'updateScript',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256',
      },
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';
